(function () {
    "use strict"
            function setCookie(name, value, days) {
                var expires = "";
                if (days) {
                    var date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = "; expires=" + date.toUTCString();
                }
                document.cookie = name + "=" + value + expires + "; path=/";
            }
            function getCookie(name) {
                var nameEQ = name + "=";
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = cookies[i];
                    while (cookie.charAt(0) === ' ') {
                        cookie = cookie.substring(1, cookie.length);
                    }
                    if (cookie.indexOf(nameEQ) === 0) {
                        return cookie.substring(nameEQ.length, cookie.length);
                    }
                }
                return null;
            }
            $('body').on('change', 'input[name="account_type"]', function () {
                var value = $(this).val();
                if (value == 'organization') {
                    $('#user').hide();
                    $('#organization').show();
                    setCookie("type", "organization", 1);
                    console.log(getCookie("type"));
                    $("#" + 'organization' + " input").each(function () {
                        var currentName = $(this).attr("name");
                        var modifiedName = currentName.replace("_del", "");
                        $(this).attr("name", modifiedName);
                    });
                } else {
                    $('#user').show();
                    $('#organization').hide();
                    setCookie("type", "user", 1);
                    $("#" + 'organization' + " input").each(function () {
                        var currentName = $(this).attr("name");
                        var modifiedName = currentName + "_del";
                        $(this).attr("name", modifiedName);
                    });
                }
        $.post('/register/form-fields', {type: value}, function (result) {
            if (result) {
                $('.js-form-fields-card').html(result.html);

                formsDatetimepicker();

                feather.replace();
            }
        })
    })
})(jQuery)
